module.exports = __webpack_public_path__ + "static/img/test.03a1ab3b.jpg";